module.exports = __webpack_public_path__ + "static/pension-2aef88def68a699a6dcb95a092cd7a1c.mp4";